import { Component, Input, OnChanges, OnInit } from '@angular/core';
// import { PDFProgressData, PDFDocumentProxy } from "ng2-pdf-viewer";
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertMessage } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'custom-pdf-viewer',
    templateUrl: 'custom-pdf-viewer.component.html',
    styleUrls: ['./custom-pdf-viewer.component.scss'],
})
export class CustomPdfViewerComponent implements OnInit, OnChanges {
    @Input() pdfSrc;
    src;

    err_msg: AlertMessage;

    pdf_error = false;
    pdf_page = 1;
    rotation = 0;
    zoom = 0.9;
    originalSize = true;
    pdf: any;
    renderText = true;
    // progressData: PDFProgressData;
    stickToPage = false;
    showAll = true;
    autoresize = true;
    fitToPage = false;
    outline: any[];
    isOutlineShown = false;
    pdfQuery = '';

    constructor(private spinner: NgxSpinnerService) {}

    ngOnInit(): void {
        this.setupCors();
    }

    ngOnChanges(): void {
        this.setupCors();
    }

    setupCors() {
        if (this.pdfSrc) {
            if (typeof this.pdfSrc == 'string') {
                this.src =
                    environment.bypassCors + environment.baseUrl + this.pdfSrc;
            } else {
                this.src = this.pdfSrc;
            }
        }
    }

    // onProgress(progressData: PDFProgressData) {
    //   this.spinner.show("custom-pdf-viewer");
    // }

    // callBackFn(pdf: PDFDocumentProxy) {
    //   this.spinner.hide("custom-pdf-viewer");
    //   this.pdf = pdf;
    // }

    onError(error: any) {
        this.pdf_error = true;
        this.spinner.hide('custom-pdf-viewer');
        console.error(error);

        if (error) {
            if (error['error']) {
                this.err_msg = {
                    text: '',
                    alert_class: 'alert-danger',
                };
                if (error['error'].non_field_errors) {
                    this.err_msg.text = error['error'].non_field_errors[0];
                } else if (error['error'].message) {
                    this.err_msg.text = error.error.message;
                } else if (error['error'].detail) {
                    this.err_msg.text = error.error.detail;
                } else {
                    this.err_msg.text = error.error.slice(0, 15) + '...';
                }
            } else {
                this.err_msg = {
                    text: '',
                    alert_class: 'alert-info',
                };
                this.err_msg.text = error['name'] + '\n' + error['statusText'];
                switch (error.status) {
                    case 0:
                        this.err_msg.text +=
                            '\nNão foi possível acessar o servidor';
                }
            }
        } else {
            this.err_msg = {
                text: 'Não foi possível exibir o documento',
                alert_class: 'alert-warning',
            };
        }
    }

    toggleOutline() {
        this.isOutlineShown = !this.isOutlineShown;
    }

    incrementPage(amount: number) {
        this.pdf_page += amount;

        if (this.pdf_page == 0) this.pdf_page = 1;
        if (this.pdf_page > this.pdf.numPages)
            this.pdf_page = this.pdf.numPages;
    }

    incrementZoom(amount: number) {
        this.zoom += amount;
    }

    rotate(angle: number) {
        this.rotation += angle;
    }

    loadOutline() {
        this.pdf.getOutline().then((outline: any[]) => {
            this.outline = outline;
        });
    }

    setPassword(password: string) {
        // let newSrc;
        // if (this.pdfSrc instanceof ArrayBuffer) {
        //   newSrc = { data: this.pdfSrc };
        // } else if (typeof this.pdfSrc === 'string') {
        //   newSrc = { url: this.pdfSrc };
        // } else {
        //   newSrc = { ...this.pdfSrc };
        // }
        // newSrc.password = password;
        // this.pdfSrc = newSrc;
    }

    getInt(value: number): number {
        return Math.round(value);
    }

    /**
     * Navigate to destination
     * @param destination
     */
    navigateTo(destination: any) {
        // this.pdfComponent.pdfLinkService.navigateTo(destination);
    }

    /**
     * Scroll view
     */
    scrollToPage() {
        // this.pdfComponent.pdfViewer.scrollPageIntoView({
        //   pageNumber: 3,
        // });
    }

    /**
     * Page rendered callback, which is called when a page is rendered (called multiple times)
     *
     * @param {CustomEvent} e
     */
    pageRendered(e: CustomEvent) {
        //console.log('(page-rendered)', e);
    }

    searchQueryChanged(newQuery: string) {
        // if (newQuery !== this.pdfQuery) {
        //   this.pdfQuery = newQuery;
        //   this.pdfComponent.pdfFindController.executeCommand('find', {
        //     query: this.pdfQuery,
        //     highlightAll: true,
        //   });
        // } else {
        //   this.pdfComponent.pdfFindController.executeCommand('findagain', {
        //     query: this.pdfQuery,
        //     highlightAll: true,
        //   });
        // }
    }
}
